<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <manual-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import ManualShowData from "./ManualShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "ManualShow",
        components: {CrudShow, ManualShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.manual.showing',
            }
        },
    }
</script>

